import type { RouteRecordRaw } from 'vue-router';

export const fileUploaderSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/file-uploader',
  name: 'FileUploaderSandbox',
  component: () => import('./pages/FileUploaderSandbox.vue'),
  meta: {
    title: 'File Uploader',
    layout: 'main',
  },
};

export const imageUploaderSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/image-uploader',
  name: 'ImageUploaderSandbox',
  component: () => import('./pages/ImageUploaderSandbox.vue'),
  meta: {
    title: 'Image Uploader',
    layout: 'main',
  },
};

export const phoneInputSandboxRoute: RouteRecordRaw = {
  path: '/sandbox/phone-input',
  name: 'PhoneInputSandbox',
  component: () => import('./pages/PhoneInputSandbox.vue'),
  meta: {
    title: 'Phone Input',
    layout: 'main',
  },
};
